import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { RootState } from '../../../../types/common.types';

import { useAdministrationApi } from '../../../../api/administration/useAdministrationApi';

import TribeHashtags from '../../../../components/screens/programme/tribe/tribe-hashtags/TribeHashtags';

const TribeHashtagsContainer = () => {
  const { hashtagOccurrences } = useSelector(({ tribe }: RootState) => tribe);

  const { programmeExternalReference } = useParams();

  const { viewHashtagOccurrences } = useAdministrationApi();

  useEffect(() => {
    viewHashtagOccurrences({ programmeExternalReference: programmeExternalReference! });
  }, [programmeExternalReference, viewHashtagOccurrences]);

  const sortedHashtags = [...hashtagOccurrences].sort((hashtagOne, hashtagTwo) => {
    const occurrenceOne = hashtagOne.occurrence;
    const occurrenceTwo = hashtagTwo.occurrence;

    if (!occurrenceOne || !occurrenceTwo) return 0;

    if (occurrenceOne > occurrenceTwo) return -1;
    if (occurrenceOne < occurrenceTwo) return 1;
    return 0;
  });

  return <TribeHashtags hashtags={sortedHashtags} />;
};

export default TribeHashtagsContainer;
